var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHummingBirdRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 100,
    viewBox: "0 0 116 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 54804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 6.14117C17.2561 2.65872 35.6645 13.8696 43.0964 18.3916C44.0167 18.9514 53.2033 25.2918 64.7918 28.1726C72.5396 30.0994 81.3597 30.4783 89.4994 26.5523C87.0527 43.0106 72.7268 56.1236 52.6398 48.399C40.714 43.8122 38.043 31.476 29.5271 23.6372C14.9634 10.2348 6.66576 7.7196 0 6.14117Z",
    fill: "url(#paint0_linear_145_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.0964 18.3899C38.5987 11.7944 32.5646 5.66913 21.787 0.0199019C43.3499 -0.537976 55.2387 10.7529 67.3556 18.7764C67.0905 23.1861 66.0162 25.7699 64.7919 28.1708C53.2052 25.29 44.0167 18.9497 43.0964 18.3899Z",
    fill: "url(#paint1_linear_145_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.683 6.16054C87.9689 8.84139 88.9417 21.6459 89.4993 26.5507C81.3597 30.4768 72.5396 30.0979 64.7917 28.171C66.0161 25.77 67.0904 23.1863 67.3555 18.7766C68.0418 0.764548 85.8496 -0.979533 91.4158 7.09731C92.04 8.16646 95.7556 7.52118 100.393 6.71585C105.286 5.86611 111.205 4.83819 115.601 5.45795C116.057 5.50936 116.139 6.12055 115.683 6.16054ZM87.3103 9.10774C87.3103 8.15954 86.5148 7.3827 85.5439 7.3827C84.573 7.3827 83.7775 8.15192 83.7775 9.10774C83.7775 10.0636 84.573 10.8328 85.5439 10.8328C86.5148 10.8328 87.3103 10.0559 87.3103 9.10774Z",
    fill: "url(#paint2_linear_145_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M89.4994 26.5508C87.0526 43.0091 72.7268 56.1221 52.6398 48.3975C44.9661 57.2778 40.5404 65.7431 38.2789 73.4848C41.7765 63.6106 56.8159 62.7405 69.1941 58.3079C84.91 52.6796 91.7181 41.9162 89.4994 26.5508Z",
    fill: "url(#paint3_linear_145_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M69.1941 58.3076C55.0515 66.2664 44.3325 72.9743 37.8129 97.5989C37.5965 98.8499 36.4872 99.7752 35.1926 99.7676C35.6176 93.6748 35.0834 84.4155 38.2769 73.4845C41.7746 63.6103 56.814 62.7402 69.1921 58.3076H69.1941Z",
    fill: "url(#paint4_linear_145_1490)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_1490",
    x1: 19.3968,
    y1: 28.0755,
    x2: 84.0853,
    y2: 28.0755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C9ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C81CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1C53C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_145_1490",
    x1: 21.787,
    y1: 14.0868,
    x2: 67.3556,
    y2: 14.0868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C9ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C81CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1C53C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_145_1490",
    x1: 64.7917,
    y1: 16.0367,
    x2: 115.987,
    y2: 16.0367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C9ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C81CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1C53C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_145_1490",
    x1: 38.2789,
    y1: 50.0178,
    x2: 89.9088,
    y2: 50.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FF9B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_145_1490",
    x1: 52.1953,
    y1: 89.1756,
    x2: 52.1953,
    y2: 58.9931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C9ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C81CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1C53C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2BBC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHummingBirdRight);
export default __webpack_public_path__ + "static/media/humming-bird-right.cbbe13faefada6084eaa21a47bd54693.svg";
export { ForwardRef as ReactComponent };